<template>
  <div>
        <el-table
             class="el-table"
            :data="info"
            ref="table"
             @sort-change="handleSortChange"
            :cell-style="{whiteSpace: 'pre-wrap'}"
            border
            max-height="780"
            style="width: 100%">
            <!--表单内容-->
            <el-table-column v-for="(item,index) in displayvalue(storeType)" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" :sortable="item.sortable" :resizable="false">
              <!-- 自定义表头 -->
              <template slot="header" slot-scope="scope">
                <span>{{ scope.column.label }}</span>
                <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
              </template>
              <template slot-scope="scope">
                <!--企业名称-->
                <div :class="{'text-center':item.center}" class="text-ellipsis"  v-if="item.pattern==='title'" @click="$emit('goStoreDetail',scope.row.id)">
                  <el-popover placement="right" trigger="hover">
                    <div>
                        <span :class="[scope.row.verify==1?'text-success':'text-danger']">{{scope.row.verify==1?'已认证':'未认证'}} </span>
                    </div>
                    <i class=" text-link male" :class="[scope.row.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference" v-if="item.title!='无'"></i>
                  </el-popover>
                  {{scope.row[item.prop]| formatString(20)}}
                </div>
                <!--企业账户-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='user_list'">
                  <p v-if="scope.row[item.prop].length>0">{{scope.row[item.prop][0].username||'无'}}</p>
                </div>
                <!--星级-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='star'">{{ scope.row[item.prop]| formatVar('HotelStar') }}</div>
                <!--创建者-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='create_uid'">{{ scope.row.create_name?scope.row.create_name:'系统管理员'}}</div>
                <!--区域-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='province'">{{scope.row[item.prop] | obtainProvince()}} {{scope.row.city| obtainProvince()}} {{scope.row.district| obtainProvince()}}</div>
                <!--是否显示-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='display'">
                  <p :class="[scope.row[item.prop]===1?'text-success':'text-danger']"> {{ scope.row[item.prop]?'已显示':'未显示'}}</p>
                </div>
                <!--是否是旅行社-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='is_travel'">
                  <p :class="[scope.row[item.prop]===1?'text-success':'']"> {{ scope.row[item.prop]?'是':'否'}}</p>
                </div>
                <!--是否是旅行社-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='bid'">
                  <p> {{ scope.row[item.prop]?scope.row[item.prop]:''}}</p>
                </div>
                <!--前台总结-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='hotel_tel'">
                  <p >{{scope.row[item.prop][0]}}</p>
                  <el-popover trigger="hover" placement="top">
                  <p v-for="(value,ins) in scope.row[item.prop]" :key="ins">总机：{{value}}</p>
                  <div slot="reference" class="icon-more" v-if="scope.row[item.prop].length>1">
                    <i class="el-icon-more" ></i>
                  </div>
                </el-popover>
                </div>
                <!--注册时间-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='note'">{{ scope.row[item.prop]| formatTimestamp(0)}}</div>
                <!--时间-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                <!--其他-->
                <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
              </template>
            </el-table-column>
              <!--操作按钮-->
              <el-table-column
                fixed="right"
                header-align="center"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button v-if="Math.abs(scope.row.refund_fee)!=scope.row.total_fee" @click="checkDetail(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">查看</el-button>
                </template>
              </el-table-column>
          </el-table>
          <!--操作面板-->
          <team-list :teamInfo="teamInfo" :cliquenumber="cliquenumber" @closeDrawer="cliquenumber=false" @handleCommand="handleCommand" :storeType="storeType" @createAccount="createAccount=true"></team-list>
          <!--添加人员弹框-->
          <el-dialog  :visible.sync="addUser" width="700px" center id="loadConfirm"  >
            <AddPersonnel :addUseItem="addUserUseItem" :storeType="storeType" @addSuccess="addSuccess"></AddPersonnel>
          </el-dialog>
          <!--更改销售职位-->
          <el-dialog :title="'销售职位'" :visible.sync="changePosition" width="700px" center id="loadConfirm">
            <ChangePosition :changeStoreid="changeStoreid" :changeUseItem="changeUseItem" @changeSuccess="changeSuccess"></ChangePosition>
          </el-dialog>
          <!--企业用户详情-->
          <el-dialog title="账户详情" :visible.sync="showDetail" center :show-close="false" width="1000px">
            <div class="d-flex flex-wrap">
              <div class="d-center-start w-50 mb-3" v-for="item in currentItem.level=='企业'?showEnterprise:showUser" :key="item.name">
                <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
              </div>
              <div class="d-center-start w-50 mb-3" v-if="currentItem.level=='企业'">
                <left-text leftText="门店账号"/>
                <span class="mr-2">{{currentItem.username}}</span>
              </div>
              <div class="d-center-start w-50 mb-3">
                <left-text leftText="账号密码"/>
                <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
                <i class="iconfont text-link" @click="showPassword = !showPassword"
                    :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
              </div>
            </div>
            <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
          </el-dialog>
          <!--创建企业账号-->
          <el-dialog :title="'创建企业账号'" :visible.sync="createAccount" width="500px" center id="loadConfirm">
            <CreateAccount :teamInfo="teamInfo" @createAccount="createAccount=false" :storeType="storeType" @createAccountSuccess="createAccountSuccess"></CreateAccount>
          </el-dialog>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapActions} from 'vuex'
  import AddPersonnel from './Components/AddPersonnel.vue'
  import TeamList from './Components/TeamList.vue'
  import ChangePosition from './Components/ChangePosition.vue'
  import CreateAccount from './Components/CreateAccount.vue'
export default {
  name: '',
  components: {AddPersonnel,TeamList,ChangePosition,CreateAccount},
  props: {
    info: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
        formList: [],
        fundsFormSupplier:[ 
          {name:'酒店名称',prop:'title',width:350,pattern:'title'},
          {name:'总客房',prop:'room_count',width:100,center:true,},
          {name:'双床房',prop:'room_2_count', minWidth:100,center:true},
          {name:'企业账号',prop:'user_list', minWidth:150,center:true,pattern:'user_list'},
          {name:'销售人数',prop:'user_count', minWidth:80,center:true,pattern:'user_count'},
          {name:'创建者',prop:'create_uid', minWidth:80,center:true,pattern:'create_uid'},
          {name:'星级',prop:'star', minWidth:100,center:true,pattern:'star'},
          {name:'前台/总机',prop:'hotel_tel', minWidth:120,center:true,pattern:'hotel_tel'},
          {name:'区域',prop:'province', minWidth:150,center:true,pattern:'province'},
          {name:'银行卡',prop:'bid',minWidth:80,center:true,pattern:'bid'},
          {name:'活跃值',prop:'exp', minWidth:100,center:true,sortable:'custom'},
          {name:'注册时间',prop:'time', minWidth:120,center:true,pattern:'note',sortable:'custom'},
          {name:'登录时间',prop:'login_update_time', minWidth:160,center:true,pattern:'time',sortable:'custom'},
          {name:'是否显示',prop:'display', minWidth:100,center:true,pattern:'display'},
        ],
        fundsFormPurchaser:[ 
          {name:'采购商名称',prop:'title',width:450,pattern:'title'},
          {name:'企业账号',prop:'user_list', minWidth:150,center:true,pattern:'user_list'},
          {name:'采购人数',prop:'user_count', minWidth:80,center:true,pattern:'user_count'},
          {name:'创建者',prop:'create_uid', minWidth:80,center:true,pattern:'create_uid'},
          {name:'前台/总机',prop:'travel_tel', minWidth:120,center:true,},
          {name:'区域',prop:'province', minWidth:150,center:true,pattern:'province'},
          {name:'银行卡',prop:'bid',minWidth:80,center:true,pattern:'bid'},
          {name:'注册时间',prop:'time', minWidth:120,center:true,pattern:'note',sortable:'custom'},
          {name:'登录时间',prop:'login_update_time', minWidth:120,center:true,pattern:'time',sortable:'custom'},
          {name:'认证旅行社',prop:'is_travel', minWidth:80,center:true,pattern:'is_travel'},
          {name:'是否显示',prop:'display', minWidth:100,center:true,pattern:'display'},
        ],
        cliquenumber:false,                     //操作面板是否显示
        teamInfo:{},                            //面板显示内容
        changePosition:false,                   //更改销售职位弹窗是否显示
        changeStoreid:'',                      //更改销售职位门店id
        changeUseItem:'',                      //更改销售职位使用项
        showDetail:false,                      //企业用户详情弹窗是否显示
        currentItem:{},                        //企业用户详情弹窗显示内容
        showPassword:false,                    //企业用户详情弹窗密码是否显示
        showUser:[
          {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户级别',value:'level'},
          {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
          {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'}
        ],
        showEnterprise:[
          {name:'用户级别',value:'level'},{name:'上次登录时间',value:'login_time'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'}
        ],
        addUser:false,                      //添加销售弹窗是否显示
        addUserUseItem:'',                    //添加销售使用项
        createAccount:false,                  //创建企业账号弹窗是否显示
    };
  },
  computed: {
    ...mapState(['userLoginMessage','AdminDataDetail']),
    storeType() { return `${this.$route.query.storeType}` || '0' },
  },
  watch: {
    info: {
      handler(newVal, oldVal) {
          // 获取table DOM滚动条回到顶部
          const tableWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
          if(tableWrapper){
            tableWrapper.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
          if(this.teamInfo.id){
          newVal.forEach(user => {
            if(user.id === this.teamInfo.id){
              this.teamInfo = user;
            }
          })
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['getItemDetail','POST_UnionRemove']),
    handleSortChange(column) {
      let SortName='',Sorts=0;
      switch(column.prop){
          case 'exp':
            SortName='exp_order'
          break;
          case 'time':
            SortName='time_order'
          break;
           case 'login_update_time':
            SortName='login_update_time_order'
      } 
      Sorts=column.order==='ascending'?2:column.order==='descending'?1:0;
      this.$emit('getDataLists',SortName,Sorts);
    },
    /*根据门店类型显示不同的表单*/
    displayvalue(storeType){
      switch(storeType*1){
        case 2:
          return this.fundsFormPurchaser
        case 3:
          return this.fundsFormSupplier
        default:
          return []
      }
    },
    /*点击操作弹出操作面板*/
    checkDetail(row){
      this.teamInfo=row;
      this.cliquenumber=true;
    },
    //点击人物操作按钮
    handleCommand(command,v,item) {
      console.log(command,v,item);
      let _this = this;
      switch (command) {
        //查看账户
        case 1:
          _this.getUserDetail(v)
          break
        //解除关联
        case 2:
          _this.deleteItem(v,item)
          break 
        //更改职位
        case 3:
          _this.changeUseItem=v;
          _this.changeStoreid=item.id
          _this.changePosition = true;
          break
        //添加销售
        case 4:
          _this.addUserUseItem=item;
          _this.addUser = true;
          break
      }
    },
    //用户详情情页
    async getUserDetail(item) {
      await this.getItemDetail({
        type:'userDetail',
        data:{
          uid:item.uid,
          // store_type:item.type
        }
      })
      this.currentItem = {
        ...this.AdminDataDetail,
        wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
        level:this.$options.filters['formatVar'](item.level,'userLevel'),
        trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
        login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
        reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
      };
      this.showDetail = true;
    },
      //解除关联
      deleteItem(v,item) {
        //删除对应元素
          // filter 返回过滤后的新数组
        this.POST_UnionRemove({data: {uid:v.uid,store_id:item.id,store_type:this.storeType},
            successFun: () => {
              //添加成功提示
              this.$message({
                  message: '解除关联成功',
                  type: 'success'
              });
              item.user_list = item.user_list.filter(user => {
                return user.uid !== v.uid
              })
              this.teamInfo=item;
              this.$emit('deleteItem',item);
            },
        });
      },
      //创建企业账号成功
      createAccountSuccess(){
        //添加成功提示
        this.$message({
            message: '创建企业账号成功',
            type: 'success'
        });
        this.createAccount = false;
        this.$emit('getDataLists',1);
      },
      //添加职位成功
      addSuccess(){
        //添加成功提示
        this.$message({
            message: '添加成功',
            type: 'success'
        });
        this.addUser = false;
        this.$emit('getDataLists',1);
      },
      //更改职位成功
      changeSuccess(item,position_name){
        //添加成功提示
        this.$message({
            message: '更改职位成功',
            type: 'success'
        });
       let teamInfo =this.teamInfo;
       teamInfo.user_list.forEach(user => {
          if(user.uid === item.uid){
            user.position_name = position_name;
          }
       })
        this.$emit('deleteItem',teamInfo);
        this.changePosition = false;
      }
  }
};
</script>

<style lang="scss" scoped>
  .icon-more{
    font-size: 12px;
    line-height: normal !important;
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform:translate(-50%,-50%);
    cursor: pointer;
    color: #999;
  }
  .comt{
    justify-content: center;
  }
  .text-ellipsis{
    cursor: pointer;
  }

</style>
<style>
  .el-table .has-gutter th,.el-table th.el-table__cell{
    background: #f7f7f9;
    color: #333;
  }
</style>
